var gmGoogleMapsLoaded = false;

function guLoadGoogleMaps( uponLoadComplete )
{
    if ( !gmGoogleMapsLoaded )
    {
        console.log("Creating new map");
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('defer', true);
        script.setAttribute('async', true);
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKXXgVQl9FU0D3yVGZ8QOd4X5R1Xw0y0&callback=' + uponLoadComplete.name;
        document.body.appendChild(script);
        gmGoogleMapsLoaded = true;
    }
    else
    {
        console.log("Initializing map");
        uponLoadComplete();
    }
}

// opacity is optional and defaults to fully opaque, so existing call sites are unaffected.
// The route map uses it to draw not-yet-selected candidate marks behind the actual route.
//
// iconType is likewise optional: it swaps only the icon (and its sizing) while the caller
// keeps its real `type`. Cruising uses it to give the departure area its own symbol without
// disturbing the 'start-finish' type, which course handling and weather routing depend on.
/**
 * labelClass (optional): CSS class(es) on the name label, e.g. tq-mark-label-beacon (race-details.css: the red
 * dot of a position from a beacon report) - the label's own colour / size stay as below unless the class
 * overrides them (tq-mark-label-sat: white on satellite imagery, the fleet page)
 */
function guSetMapMarker( map, type, name, pos, opacity, iconType, labelClass )
{
    // Check that we have valid coordinates
    if ( pos.lat() === 0 || pos.lng() === 0 ) return;

    // If we have a valid start-finish position don't draw the finish mark as the
    // start is already there (named "START")
    if ( name === "START-FINISH" ) return;

    if ( type === undefined || type === null ) return;

    // Change the original '_' to '-'
    type = type.replace('_', '-');

    // Everything below uses `type` only to choose the symbol and its size, so an icon
    // override can simply stand in for it here - the caller's real type is untouched
    if ( iconType !== undefined && iconType !== null ) type = iconType;

    // Accommodate larger icons
    var sSize, anchor, lOrigin;
    if ( type === "cm-entry"
         || type === "dng"
         || type === "dng-n"
         || type === "dng-s"
         || type === "dng-e"
         || type === "dng-w"
         || type === "range-back" )
    {
        sSize =  new google.maps.Size(30, 30);
        anchor = new google.maps.Point(15, 30);
        lOrigin = new google.maps.Point(10, 26);
    }
    else if ( type === 'lighthouse'
              || type === 'rock' )
    {
        sSize =  new google.maps.Size(20, 36);
        anchor = new google.maps.Point(10, 36)
        lOrig = new google.maps.Point(10, 38);
    }
    else if ( type === "start-finish" )
    {
        sSize =  new google.maps.Size(60, 12);
        anchor = new google.maps.Point(20, 12)
        lOrigin = new google.maps.Point(24, 20);
    }
    else if ( type === "dyn-finish-line-pt" )
    {
        sSize =  new google.maps.Size(30, 15);
        anchor = new google.maps.Point(15, 15);
        lOrigin = new google.maps.Point(15, 26);
    }
    else
    {
        sSize =  new google.maps.Size(20, 20);
        anchor = new google.maps.Point(10, 20);
        lOrigin = new google.maps.Point(10, 26);
    }

    var icon = {
        url: markIconPrefix + '/mark-' + type + '@2x.png',
        scaledSize: sSize,
        origin: new google.maps.Point(0, 0),
        anchor: anchor,
        labelOrigin: lOrigin
    };

    var label = {
        text: name,
        color: "#1e567e",
        fontSize: "8px"
    }
    if ( labelClass !== undefined && labelClass !== null ) label.className = labelClass;

    // Returned so callers can hook the marker up - a marker consumes clicks that would
    // otherwise reach the map, so anything relying on map clicks has to handle it too
    return new google.maps.Marker( {
        position: pos,
        icon: icon,
        map: map,
        label: label,
        opacity: (opacity === undefined || opacity === null ? 1.0 : opacity)
    } );
}

/** labelClass (optional) as for guSetMapMarker: a CSS class on the line's name label */
function guSetGeoLine( map, type, name, fromPos, toPos, labelClass )
{
    // Check that we have valid coordinates
    if ( fromPos.lat() === 0 || fromPos.lng() === 0 || toPos.lat() === 0 || toPos.lng() === 0 ) return;

    var isCourseGate = type.startsWith('gate-');
    var color = type.replace('gate-', '');

    // Draw boat and pint end
    var iconBoat = {
        url: markIconPrefix + (isCourseGate ? '/mark-cyl-' + color + '@2x.png' : '/mark-start-boat@2x.png'),
        scaledSize: new google.maps.Size((isCourseGate ? 20 : 40), 20),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point((isCourseGate ? 10 : 20), 20),
        labelOrigin: new google.maps.Point(30, 30)
    };

    var label = {
        text: name,
        color: (isCourseGate ? '#444' : (type ==='start-line' ? '#489512' : '#91201a')),
        fontSize: "8px"
    };
    if ( labelClass !== undefined && labelClass !== null ) label.className = labelClass;

    var sbMarker = new google.maps.Marker(
        { position: fromPos,
          icon: iconBoat,
          map: map,
          label: label,
          draggable: false });

    // Draw boat and pint end
    var iconPin = {
        url: markIconPrefix + (isCourseGate ? '/mark-cyl-' + color + '@2x.png' : '/mark-start-pin@2x.png'),
        scaledSize: new google.maps.Size(20, (isCourseGate ? 20 : 26)),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point((isCourseGate ? 10 : 6), (isCourseGate ? 20 : 24))
    };

    var ptMarker = new google.maps.Marker(
        { position: toPos,
          icon: iconPin,
          map: map,
          draggable: false });

    // Draw line
    var courseCoordinates = new Array();
    courseCoordinates.push(fromPos);
    courseCoordinates.push(toPos);

    var lineColor = (isCourseGate ? '#444' : (type === 'start-line' ? '#489512' : '#91201a'));

    var lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeColor: lineColor,
        strokeOpacity: 1.0,
        strokeWeight: 1.5,
        scale: 3
    };

    var line = new google.maps.Polyline({
        path: courseCoordinates,
        geodesic: true,
        strokeOpacity: 0.0,
        icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5px'
        }],
        map: map
    });
}

/***************** Mercator Projection for static gmap tiles *******************/

var MERCATOR_RANGE = 256;

function mercator_bound(value, opt_min, opt_max) {
    if (opt_min != null) value = Math.max(value, opt_min);
    if (opt_max != null) value = Math.min(value, opt_max);
    return value;
}

function mercator_degreesToRadians(deg) {
    return deg * (Math.PI / 180);
}

function mercator_radiansToDegrees(rad) {
    return rad / (Math.PI / 180);
}

function MercatorProjection() {
    this.pixelOrigin_ = { x: MERCATOR_RANGE / 2, y: MERCATOR_RANGE / 2 };
    this.pixelsPerLonDegree_ = MERCATOR_RANGE / 360;
    this.pixelsPerLonRadian_ = MERCATOR_RANGE / (2 * Math.PI);
};

// Takes a { lat, lon } object and finds the pixel position
MercatorProjection.prototype.fromLatLonToPoint = function( latLon, opt_point )
{
    //pixelCoordinate = worldCoordinate * Math.pow(2,zoomLevel)
    var me = this;

    var point = opt_point || { x: 0.0, y: 0.0 };

    var origin = me.pixelOrigin_;
    point.x = origin.x + latLon.lon * me.pixelsPerLonDegree_;
    // NOTE(appleton): Truncating to 0.9999 effectively limits latitude to
    // 89.189.  This is about a third of a tile past the edge of the world tile.
    var siny = mercator_bound(Math.sin(mercator_degreesToRadians(latLon.lat)), -0.9999, 0.9999);
    point.y = origin.y + 0.5 * Math.log((1 + siny) / (1 - siny)) * -me.pixelsPerLonRadian_;
    return point;
};

// Takes a { x, y } object and returns the lat, lon object for it
MercatorProjection.prototype.fromPointToLatLon = function( point )
{
    var me = this;

    var origin = me.pixelOrigin_;
    var lon = (point.x - origin.x) / me.pixelsPerLonDegree_;
    var latRadians = (point.y - origin.y) / -me.pixelsPerLonRadian_;
    var lat = mercator_radiansToDegrees(2 * Math.atan(Math.exp(latRadians)) - Math.PI / 2);

    return { lat: lat, lon: lon };
};

guGetGmapCorners = function( center, zoom, mapWidth, mapHeight )
{
    var proj = new MercatorProjection();

    var scale = Math.pow(2,zoom);
    var centerPx = proj.fromLatLonToPoint(center);
    var swPoint = {x: (centerPx.x -(mapWidth/2)/ scale) , y: (centerPx.y + (mapHeight/2)/ scale)};
    var swLatLon = proj.fromPointToLatLon(swPoint);
    var nePoint = {x: (centerPx.x +(mapWidth/2)/ scale) , y: (centerPx.y - (mapHeight/2)/ scale)};
    var neLatLon = proj.fromPointToLatLon(nePoint);

    return { sw: swLatLon, ne: neLatLon };
}
